//动态路由
import Layout from '../pages/layout';
import groundPark from './ground-parking';
let router0 = [
  {
    path: '/p',
    component: Layout,
    meta: { title: '停车管理', icon: 'parking' },
    children: [{
      path: 'park/manage',
      component: require('@/pages/app/parkInfo/Manage.vue'),
      name: 'park:manage',
      meta: { title: '停车场管理', roles: [1] }
    }, {
      path: 'accessInfo/manage',
      component: require('@/pages/app/accessInfo/Manage.vue'),
      name: 'accessInfo:manage',
      meta: { title: '停车流水', roles: [1] }
    },
    ],
  }, {
    path: '/f',
    component: Layout,
    meta: { title: '支付结算', icon: 'finance' },
    children: [
      /*   {
         path: 'settleAccount/manage',
         component: require('@/pages/app/settleAccount/Manage.vue'),
         name: 'settleAccount:manage',
         meta: { title:'收款账户管理' }
       },*/
      {
        path: 'payOrder/manage',
        component: require('@/pages/app/payOrder/Manage.vue'),
        name: 'payOrder:manage',
        meta: { title: '支付记录', roles: [1] }
      }],
  },
  {
    path: '/act',
    component: Layout,
    meta: { title: '活动及营销', icon: 'promotion' },
    children: [{
      path: 'promotionDispatchChannel/manage',
      component: require('@/pages/app/act/promotionDispatchChannel/Manage.vue'),
      name: 'promotionDispatchChannel:manage',
      meta: { title: '渠道管理', roles: [1] }
    }, {
      path: 'promotion/manage',
      component: require('@/pages/app/act/promotionInfo/Manage.vue'),
      name: 'promotion:manage',
      meta: { title: '优惠管理', roles: [1] }
    }, {
      path: 'couponBatch/manage',
      component: require('@/pages/app/act/promotionCouponBatch/Manage.vue'),
      name: 'couponBatch:manage',
      meta: { title: '优惠券派发', roles: [1] }
    }, {
      path: 'coupon/manage',
      component: require('@/pages/app/act/promotionCoupon/Manage.vue'),
      name: 'coupon:manage',
      meta: { title: '优惠券', roles: [1] }
    }],
  }, {
    path: '/r',
    component: Layout,
    meta: { title: '订单及报表', icon: 'cart' },
    children: [{
      path: 'parkingOrder/manage',
      component: require('@/pages/app/parkingOrder/Manage.vue'),
      name: 'parkingOrder:manage',
      meta: { title: '订单管理', roles: [1] }
    }, {
      path: 'coupon/report',
      component: require('@/pages/app/report/CouponReport.vue'),
      name: 'coupon:report',
      meta: { title: '优惠券统计', roles: [1] }
    }]
  },
  ...groundPark
]

export const asyncRouter = [].concat(router0)
// export const asyncRouter = sysRouter



// WEBPACK FOOTER //
// ./src/router/asyncRouter.js